export default function groupTargetMedias(targetMedias, getLabel) {
    const sorted = targetMedias.map(media => ({ media, label: getLabel(media) }))
        .sort((a, b) => a.label.localeCompare(b.label, 'fi'));
    const groups = new Map();
    sorted.forEach(item => {
        const letter = item.label.trim().charAt(0).toLocaleUpperCase('fi');
        if (!groups.has(letter)) groups.set(letter, []);
        groups.get(letter).push(item);
    });
    return Array.from(groups);
}
